// @flow
import React, { type Node, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'ramda';

import type { Complex } from 'app/common/components/Cafeteria/dataTypes/order/Complex.types';
import { useCurrencySign } from 'app/common/components-next/currency';
import { ContentScrollbars } from 'app/common/ui-next/plain-modal';

import ComplexItem from '../../../../commonComponents/ComplexItem';
import ExchangeColumnHeader from './ExchangeColumnHeader';
import ExchangeColumnFooter from './ExchangeColumnFooter';


type Props = {
  headerClassName?: string,
  contentClassName?: string,
  footerClassName?: string,
  itemClassName?: string,
  targetName?: string,
  items: Array<Complex>,
  checkedId: string | null,
  disabled?: boolean,
  children: Node,
  onCancelExchange: () => void,
  onCommitExchange: () => void,
  onCheckItem: (id: string) => void,
}

const ExchangeSources = ({
  headerClassName,
  contentClassName,
  footerClassName,
  itemClassName,
  targetName = 'Имя не определено',
  items,
  checkedId,
  disabled: disabledExternal,
  children,
  onCancelExchange,
  onCommitExchange,
  onCheckItem,
}: Props): Node => {
  const currency = useCurrencySign();
  const { t } = useTranslation('cafeteria');
  const headerTitle = t('order_request_sales_exchange_complex_sorce_column_title', { target: targetName });

  const description = t(
    'order_request_sales_exchange_complex_sorce_column_description',
    'Для замены, выберите комплект из списка',
  );

  const confirmBtTitle = t('order_request_sales_exchange_complex_sorce_column_confirm_bt', 'Заменить');
  const cancelBtTitle = t('order_request_sales_exchange_complex_sorce_column_cancel_bt', 'Отмена');

  const nothing = isEmpty(items);

  return (
    <Fragment>
      <ExchangeColumnHeader
        className={headerClassName}
        title={headerTitle}
        description={description}
      />
      <div className={contentClassName}>
        {nothing && children}

        {!nothing && <ContentScrollbars maxHeight="55vh">
          {items.map(({
            id,
            title,
            dishes,
            cost,
            disabled,
            disabledReason,
            freeCount,
          }) => (
            <ComplexItem
              className={itemClassName}
              key={id}
              id={id}
              title={title}
              dishes={dishes}
              cost={cost}
              currency={currency}
              onCheck={onCheckItem}
              checked={checkedId === id}
              disabled={disabled || disabledExternal}
              disabledReason={disabledReason}
              isFree={!!freeCount}
            />
          ))}
        </ContentScrollbars>}
      </div>

      {!nothing
        && <ExchangeColumnFooter
          className={footerClassName}
          disabled={!checkedId}
          confirmBtTitle={confirmBtTitle}
          cancelBtTitle={cancelBtTitle}
          onCancel={onCancelExchange}
          onCommit={onCommitExchange}
        />}
    </Fragment>
  );
};

export default ExchangeSources;
